import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import CalendarRow from 'calendarRow';
import CalendarDayCell from 'calendarDayCell';
import CalendarLegendCell from 'calendarLegendCell';
import S from 'calendar.scss';
import CalendarNavigationButton from 'calendarNavigationButton';

require('moment-range');

class CalendarHeader extends Component {
  constructor(props) {
    super(props);
    this.calendarHeaderRef = createRef();
  }

  renderDay = (date, i, total, navigatePast, navigateFuture) => {
    const m = date.startOf('day');
    return (<CalendarDayCell
      key={date.toString()}
      className={`${S.headerCell} ${Moment().startOf('day').isSame(m) ? S.today : ''}`}
    >
      {i === 0 && <CalendarNavigationButton
        increment={0 - total}
        className={S.prevButton}
        icon="navigate_before"
        navigate={navigatePast}
      />}
      {m.format('ddd MM/DD')}
      {i === (total - 1) && <CalendarNavigationButton
        increment={total}
        className={S.nextButton}
        icon="navigate_next"
        navigate={navigateFuture}
      />}
    </CalendarDayCell>);
  };

  render = () => {
    const { dates, navigatePast, navigateFuture, className } = this.props;
    return (<CalendarRow className={`${className} ${S.headerRow}`}>
      <div ref={this.calendarHeaderRef} />
      <CalendarLegendCell />
      {dates.map((day, i) =>
        this.renderDay(day, i, dates.length, navigatePast, navigateFuture))}
    </CalendarRow>);
  }
}

CalendarHeader.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.instanceOf(Moment)).isRequired,
  navigatePast: PropTypes.func,
  navigateFuture: PropTypes.func,
  className: PropTypes.string,
};

CalendarHeader.defaultProps = { className: '' };

export default CalendarHeader;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarHeader.jsx